import { Routes } from '@angular/router';
import { clientIdChildGuard, clientIdGuard } from '../guards/client-id/client-id.guard';
import { OnboardingWizardComponent } from '../components/onboarding-wizard/onboarding-wizard.component';
import { FdEmptyRouteComponentComponent } from '../components/shared/fd-empty-route-component/fd-empty-route-component.component';
import { ProfileResolver } from '../resolvers/profile.resolver';
import { fdUserGuardOnboarding } from '../guards/fd-user/fd-user-onboarding.guard';
import { authGuard } from '../guards/auth.guard';

export const onboardingWizardRoutes: Routes = [
    {
        path: 'client-onboarding/:clientId/:onboardingId',
        component: OnboardingWizardComponent,
        canActivate: [authGuard, clientIdGuard, fdUserGuardOnboarding],
        canActivateChild: [clientIdChildGuard,],
        resolve: { profile: ProfileResolver },
        children: [
            { path: '', pathMatch: 'full', loadComponent: () => Promise.resolve(FdEmptyRouteComponentComponent) },
            {
                path: 'contract-data',
                loadComponent: () =>
                    import('../components/onboarding-wizard/contract-data/contract-data.component').then(
                        (m) => m.ContractDataComponent
                    ),
            },
            {
                path: 'client-data-review',
                loadComponent: () =>
                    import('../components/onboarding-wizard/client-data-review/client-data-review.component').then(
                        (m) => m.ClientDataReviewComponent
                    ),
            },
            {
                path: 'mids',
                // providers: [VarSheetStateService],
                children: [
                    // {
                    //     path: '',
                    //     pathMatch: 'full',
                    //     loadComponent: () =>
                    //         import('../components/onboarding-wizard/mids-step/mids-decision/mids-decision.component').then(
                    //             (m) => m.MidsDecisionComponent
                    //         ),
                    // },
                    {
                        path: '',
                        loadComponent: () =>
                            import('../components/onboarding-wizard/mids-step/mids-information/mids-information.component').then(
                                (m) => m.MidsInformationComponent
                            ),
                    },
                    {
                        path: 'var',
                        children: [
                            {
                                path: 'upload',
                                loadComponent: () =>
                                    import('../components/onboarding-wizard/mids-step/var-sheet-flow/var-upload/var-upload.component')
                                        .then(m => m.VarUploadComponent),
                            },
                            {
                                path: 'review',
                                loadComponent: () =>
                                    import('../components/onboarding-wizard/mids-step/var-sheet-flow/var-grid/var-grid.component')
                                        .then(m => m.VarGridComponent),
                            },
                        ],
                    },
                    { path: '**', redirectTo: '' },

                ],
            },
            {
                path: 'services-settings',
                loadComponent: () =>
                    import('../components/onboarding-wizard/services-settings/services-settings.component').then(
                        (m) => m.ServicesSettingsComponent
                    ),
            },
            {
                path: 'credentials',
                loadComponent: () =>
                    import('../components/onboarding-wizard/credentials/credentials.component').then(
                        (m) => m.CredentialsComponent
                    ),
                children: [
                    {
                        path: '',
                        pathMatch: 'full',
                        loadComponent: () =>
                            import('../components/onboarding-wizard/credentials/credentials-acknowledge/credentials-acknowledge.component').then(
                                (m) => m.CredentialsAcknowledgeComponent
                            ),
                    },
                    {
                        path: 'list',
                        loadComponent: () =>
                            import('../components/onboarding-wizard/credentials/credentials-list/credentials-list.component').then(
                                (m) => m.CredentialsListComponent
                            ),
                    },
                    {
                        path: 'add',
                        loadComponent: () =>
                            import('../components/onboarding-wizard/credentials/credentials-form/credentials-form.component').then(
                                (m) => m.CredentialsFormComponent
                            ),
                    },
                ],
            },
            {
                path: 'ach',
                loadComponent: () =>
                    import('../components/onboarding-wizard/ach/ach.component').then(
                        (m) => m.AchComponent
                    ),
            },
            {
                path: 'onboarding-review',
                loadComponent: () =>
                    import('../components/onboarding-wizard/onboarding-review/onboarding-review.component').then(
                        (m) => m.OnboardingReviewComponent
                    ),
            },
            {
                path: 'fd-review',
                resolve: { profile: ProfileResolver },
                loadComponent: () =>
                    import('../components/onboarding-wizard/fd-review/fd-review.component').then(
                        (m) => m.FdReviewComponent
                    ),
            },
        ],
    },
];
